import * as ngCore from '@angular/core'

import * as state from '../../../../../../../state'

/** TODO:  */
@ngCore.Injectable()
export class AiAssistantOrchestrator {
  /** @see {@link state.assistant.oneOff.Feature} */
  public readonly assistantSg = ngCore.signal<
    state.assistant.oneOff.Feature | undefined
  >(undefined)
}
